import { ClipType } from '@air/api/types';

export const isTimestampableClipType = (clipType?: ClipType | null) =>
  clipType === ClipType.video || clipType === ClipType.audio;
